import React from 'react';
import Hero from './Hero';
import Features from './Features';
import Pricing from './Pricing';
import FAQ from './FAQ';
import Contact from './Contact';
import CTA from './CTA';
import ProductDefinition from './ProductDefinition';
import HowItWorks from './HowItWorks';
import { Helmet } from 'react-helmet';
import { certyEntityGraph } from '../seo/entity';

const Home: React.FC = () => {
  return (
    <>
      <Helmet defer={false}>
        <title>Certy | Gestión de certificados digitales en Windows</title>
        <meta name="description" content="Gestiona certificados digitales en Windows y abre varios portales a la vez, cada uno con su certificado. Búsqueda, importación, firma PDF y avisos." />
        <meta name="keywords" content="certificados digitales, gestor de certificados digitales, AEAT, Seguridad Social, LexNET, gestorías, despachos, administración pública" />
        <link rel="canonical" href="https://certy.es/" />
        <meta property="og:title" content="Certy | Gestión de certificados digitales en Windows" />
        <meta property="og:description" content="Abre varios portales a la vez, cada uno con su certificado. Organiza, importa, firma PDF y recibe avisos desde Certy." />
        <meta property="og:url" content="https://certy.es/" />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="Certy" />
        <meta property="og:locale" content="es_ES" />
        <meta property="og:image" content="https://certy.es/product/certy-multiples-pestanas.png" />
        <meta name="twitter:card" content="summary_large_image" />
        <script type="application/ld+json">{JSON.stringify(certyEntityGraph)}</script>
      </Helmet>
      <main className="min-h-screen w-full max-w-full overflow-x-hidden bg-white">
        <Hero />
        <ProductDefinition />
        <Features />
        <HowItWorks />
        <Pricing />
        <FAQ />
        <Contact />
        <CTA />
      </main>
    </>
  );
};

export default Home; 
